import React from "react";
import { connect } from "react-redux";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";


// components
import {LangController} from "../../../components/tabs/langController";

// labels
import { FL_IMAGE, FL_LONG_DESCRIPTION, FL_PRESENTATION, FL_SHORT_DESCRIPTION, FL_TITLE } from "../../../components/i18n/formLabels";
import { PH_IMAGE, PH_LONG_DESCRIPTION, PH_PRESENTATION, PH_SHORT_DESCRIPTION, PH_TITLE } from "../../../components/i18n/placeHolders";

// actions
import { searchActiveLangs } from "../../../redux/actions/langActions";
import { setLangsInData } from "../../../redux/actions/genericActions";


const HotelCategoryLangs = props => {
	const setDataDefault = (activeLangs, setLangChilds) => {
		const items = activeLangs.map( lang => ({
			id: '',
			lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
			title: '',
			image: '',
			presentation: '',
			longDescription: '',
			shortDescription: '',
			buttonLabel: '',
			navigationUrl: '',
		}) )

		setLangChilds(items);
	}


	const getFormulary = (child, index, disableInputs, onInputChange) => <>
		<Row>
			<Col md={'8'}>
				<FormGroup>
					<Label>{FL_TITLE}</Label>
					<Input
						type="text"
						name="title"
						placeholder={PH_TITLE}
						value= { child.title }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col>
				<FormGroup>
					<Label>{'Texto del Botón'}</Label>
					<Input
						type="text"
						name="buttonLabel"
						placeholder={'Texto del Botón'}
						value= { child.buttonLabel }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
			<Col>
				<FormGroup>
					<Label>{FL_IMAGE}</Label>
					<Input
						type="text"
						name="image"
						placeholder={PH_IMAGE}
						value= { child.image }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col>
				<FormGroup>
					<Label>{FL_PRESENTATION}</Label>
					<Input
						type="text"
						name="presentation"
						placeholder={PH_PRESENTATION}
						value= { child.presentation }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col>
				<FormGroup>
					<Label>{FL_SHORT_DESCRIPTION}</Label>
					<Input
						type="textarea"
						name="shortDescription"
						rows={"3"}
						placeholder={PH_SHORT_DESCRIPTION}
						value= { child.shortDescription }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col>
				<FormGroup>
					<Label>{FL_LONG_DESCRIPTION}</Label>
					<Input
						type="textarea"
						name="longDescription"
						rows={"8"}
						placeholder={PH_LONG_DESCRIPTION}
						value= { child.longDescription }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col>
				<FormGroup>
					<Label>{'URL de Navegación'}</Label>
					<Input
						type="text"
						name="navigationUrl"
						placeholder={'URL de Navegación'}
						value= { child.navigationUrl }
						onChange={e => onInputChange(e, child.lang)}
						disabled={disableInputs}
					/>
				</FormGroup>
			</Col>
		</Row>
	</>

	return <LangController
		langs={props.langs}
		setLangs={props.setLangs}
		getFormulary={getFormulary}
		setDataDefault={setDataDefault}
		translatableLangs={props.translatableLangs}
	/>
}

const mapStateToPropsLang = state => ({
	activeLangs : state.langs,
	categoryInfo : state.genericInfo,
})

const mapActionsToPropsLang = ({
	searchActiveLangs,
	setLangsInData,
})

export default connect(mapStateToPropsLang, mapActionsToPropsLang)(HotelCategoryLangs)